import { Component } from '@mycolorway/tao';
import 'next/stylesheets/components/grid/subtodo-group.scss';
import { closest } from 'next/javascripts/modules/dom';
import $ from 'jquery';
import Sortable from 'sortablejs';

Component('tr-grid-subtodo-group', {
  properties: {
    parentGuid: {
      type: String,
    },
    loadUrl: String,
    loading: {
      type: Boolean,
      default: false,
      observer: 'loadingChanged',
    },
    count: {
      type: Number,
      default: 1,
    },
    sortable: Boolean,
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.content = this.querySelector('.content');

    this.deep = 1;
    const group = closest(this.parentElement, 'tr-grid-subtodo-group');
    if (group) {
      this.deep = group.getDeep() + 1;
    }

    this.loader = this.querySelector('.loading-list');
    this.loadItem = document.importNode(
      this.querySelector('template').content, true,
    ).firstElementChild;
    const left = this.calcIndentSize() + 10;
    this.loadItem.style.paddingLeft = `${left}px`;

    if (this.sortable) this.initSortable();
  },

  initSortable() {
    this.sortableInstance = Sortable.create(this.content, {
      group: 'tr-grid-todo-row',
      sort: true,
      draggable: 'tr-grid-todo-row[sortable]:not([editing])',
      handle: '.grid-sticky-cell',
      delay: 50,
      animation: false,
      invertSwap: true,
      fallbackOnBody: true,
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
      onChoose: (e) => {
        this.namespacedTrigger('sortableOnChoose', { detail: e, bubbles: true });
      },
      onUnchoose: (e) => {
        this.namespacedTrigger('sortableOnUnchoose', { detail: e, bubbles: true });
      },
      onStart: ({ item }) => {
        item.classList.add('sortable-sorting');
      },
      onEnd: ({
        to, from, item, oldDraggableIndex, newDraggableIndex,
      }) => {
        item.classList.remove('sortable-sorting');

        const changed = from !== to || oldDraggableIndex !== newDraggableIndex;
        this.namespacedTrigger('rowSortableEnd', {
          detail: { item, changed },
          bubbles: true,
        });
      },
    });
  },

  loadingChanged(loading) {
    if (loading) {
      for (let i = this.count - 1; i >= 0; i -= 1) {
        const item = this.loadItem.cloneNode(true);
        const num = Math.round(Math.random() * (100 - 60) + 60);
        item.querySelector('.line').style.width = `${num}%`;
        this.loader.insertAdjacentElement('beforeend', item);
      }
    } else {
      this.loader.innerHTML = '';
    }
  },

  getDeep() {
    return this.deep;
  },

  calcIndentSize() {
    return (this.deep + 1) * 24;
  },

  appendTodosHTML(html) {
    this.content.insertAdjacentHTML('beforeend', html);
    this.loading = false;
  },

  loadOnce() {
    if (!this.loaded) {
      this.load();
    }
  },

  load({ silence = false } = {}) {
    if (!this.loadUrl || this.loading) {
      return;
    }

    const last = this.content.lastElementChild;

    this.loading = !silence;
    $.ajax({
      url: this.loadUrl,
      method: 'get',
      data: {
        last_guid: last ? (last.guid || last.parentGuid) : null,
      },
      dataType: 'script',
      complete: () => {
        this.loaded = true;
      },
    });
  },

  getLastRow() {
    return this.content.querySelector(':scope > tr-grid-todo-row:last-of-type');
  },

  destroySortable() {
    if (this.sortableInstance) this.sortableInstance.destroy();
  },
});
